module.exports = "./img/3dac98a5394e443017fcd89e29e08965.jpg";